<template>
  <v-row class="mx-auto">
    <v-col cols="12">
      <v-card outlined :loading="loading" :disabled="loading">
        <v-card-title class="subtitle-1">{{ dynamicLabel }}</v-card-title>
        <v-card-text>
          <div class="d-flex align-center">
            <v-btn class="mr-2" color="primary" @click="clickAddNewLine()"><v-icon left>mdi-plus</v-icon>Selecionar Linha</v-btn>
            <v-btn v-if="groupUser == 1 || groupUser == 2" color="success" @click="showModalImport = true"><v-icon left>mdi-database-import</v-icon>Importar arquivo</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      sm="6"
      v-for="(lineSelected, index) in lineSelect"
      :key="index"
    >
      <v-card outlined class="mx-auto">
        <v-card-title class="primary white--text">
          <div class="headerClass">
            {{lineSelected && lineSelected.ddi ? lineSelected.ddi+' ('+lineSelected.ddd+') '+lineSelected.nr_linha : 'Selecione uma linha' }}
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeLine(index)" class="mx-3 mt-2">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <LineComponent
                :rules="[v => (v && Object.keys(v).length > 0) || 'Obrigatório']"
                :selectedLine="lineSelected"
                @save="
                  lineSelected = $event;
                  updateSelectedLine($event, index);
                "
              ></LineComponent>

              <v-autocomplete
                v-if="groupUser == 1 || groupUser == 2"
                dense
                outlined
                required
                label="Aparelho"
                v-model="lineSelected.aparelho"
                :items="GROUP_MOVTO_APARELHO"
                item-text="name"
                item-value="value"
                return-object
                @change="updateSelectedLine(lineSelected, index)"
              >
              </v-autocomplete>

              <v-autocomplete
                v-if="(groupUser == 1 || groupUser == 2) && lineSelected.aparelho && lineSelected.aparelho.value == 5"
                dense
                outlined
                required
                label="Tipo Baixa"
                v-model="lineSelected.tipo_baixa"
                :items="GROUP_TIPO_BAIXA"
                :rules="[v => !!v || 'Obrigatório']"
                item-text="name"
                item-value="value"
                @change="updateSelectedLine(lineSelected, index)"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <ImportDataSolicitationDialogComponent
      v-if="showModalImport"
      :title="'Linhas Identificadas'"
      @closeDialog="showModalImport = false"
      @importValues="importValues($event)"
    ></ImportDataSolicitationDialogComponent>
  </v-row>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import LineComponent from "@/components/forms/LineComponent.vue";
import ImportDataSolicitationDialogComponent from "@/components/dialog/ImportDataSolicitationDialogComponent.vue";
import isEmpty from "lodash/isEmpty";
import { GROUP_MOVTO_APARELHO, GROUP_TIPO_BAIXA } from "../../helpers/constants";
export default {
  components: { LineComponent, ImportDataSolicitationDialogComponent },
  props: {
    index: {},
    groupUser: {},
    uniqueKeyStorage: {
      type: String,
      default: ''
    },
    page: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      lineSelect: [],
      loading: true,
      show: false,
      showModalImport: false,
      dynamicLabel: "",
      resultStorage: null,
      maxLength: 50,
      lineRules: [v => !!v || "Linha é obrigatório"],
    };
  },
  async mounted() {
    if (this.wizard.model["suspend_line"] || this.wizard.model["cancel_line"]) {
      this.wizard.forms.map(form => {
        if (form.type == "suspend_line" || form.type == "cancel_line")
          this.dynamicLabel = form.label;
      });
    }

    this.lineSelect = [...this.lineSelect, {}];

    const dataLocalStorage = await this.loadDataLocalStorage(this.uniqueKeyStorage);
    if (!isEmpty(dataLocalStorage) && this.page === 'wizard') {
      this.resultStorage = dataLocalStorage;
      this.lineSelect = Object.assign([], this.resultStorage);
    }

    this.loading = false;
  },
  computed: {
    GROUP_MOVTO_APARELHO() {
      return GROUP_MOVTO_APARELHO
    },
    GROUP_TIPO_BAIXA() {
      return GROUP_TIPO_BAIXA
    },
    ...mapState("packages", ["lines"]),
    ...mapState("forms", ["wizard"]),

    ...mapGetters({
      linePackages: "packages/getLinePackages"
    })
  },
  methods: {
    ...mapActions("packages", ["loadLinePackages"]),
    ...mapActions("solicitation", ["loadDataLocalStorage"]),
    ...mapMutations({
      setModel: "forms/setModelCancelLine"
    }),
    async clickAddNewLine() {
      if (this.lineSelect.length >= this.maxLength) {
        await this.$swal("Limite máximo atingido", 'O número máximo de cards dessa solicitação é '+this.maxLength+'.', "info");
      } else {
        this.lineSelect = [ {}, ...this.lineSelect ];
      }
    },
    importValues(data) {
      const existingIds = new Set(this.lineSelect.map(item => item.id_linha));
      const filtered = data.filter(
        item => !existingIds.has(item.id_linha)
      );

      this.lineSelect.push(...filtered);
      this.updateValues(this.lineSelect);
      this.showModalImport = false;
    },
    async updateSelectedLine(lineSelected, index) {
      const exists = this.lineSelect.some((line, i) => line.id_linha === lineSelected.id_linha && i !== index);

      if (exists) {
        this.lineSelect[index] = [];
        this.lineSelect = Object.assign([], this.lineSelect);
        await this.$swal("Linha já selecionada!", "", "warning");
        return;
      }

      this.lineSelect[index] = lineSelected;
      this.lineSelect = Object.assign([], this.lineSelect);
      this.updateValues(this.lineSelect);
    },
    updateValues(cancelLineList) {
      const payload = {
        step: this.index,
        selected: cancelLineList
      };
      this.setModel(payload);
      if (this.page === 'wizard') {
        localStorage.setItem(this.uniqueKeyStorage, JSON.stringify(cancelLineList));
      }
    },
    closeLine(index) {
      if (index > -1) {
        this.lineSelect.splice(index, 1);
      }
      this.updateValues(this.lineSelect);
    },
  }
};
</script>
<style scoped>
.headerClass {
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
